(function(angular){
    'use strict';
    var app = angular.module('enervee');
    
    app.factory('DeleteAccountService', [
        'UserApiConsumerService',
        function(
            UserApiConsumerService
        ) {
            var _pub = {};
            var _deleteAccountResponse = null;

            /**
             * Deletes the account if the password is valid
             *
             * @param password: currently logged in user's password.
             * @returns {*}
             */
            _pub.deleteAccount = function(password) {
                var data = {
                    'password': password
                };

                return UserApiConsumerService.post('api/1.0/rest-auth/account/delete/', data)
                    .then(
                        // success
                        function(response) {
                            _deleteAccountResponse = {
                                'success': true,
                                'message': response.success
                            };
                        },
                        // error
                        function(response) {
                            _deleteAccountResponse = {
                                'success': false, 
                                'error': response.data
                            };
                        }
                    );
            };


            /**
             * Gets the response of the delete account response api call
             *
             * @returns {*}
             */
            _pub.getDeleteAccountResponse = function(){
                return _deleteAccountResponse;
            };
            
            return _pub;
        }
    ]);
})(angular);